import type { BidEvent, Metric, Vehicle } from "../types";

const gallery = (id: string) => [
  `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=1200&q=82`,
  "https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?auto=format&fit=crop&w=1200&q=82",
  "https://images.unsplash.com/photo-1502877338535-766e1452684a?auto=format&fit=crop&w=1200&q=82"
];

export const vehicles: Vehicle[] = [
  {
    id: "VX-23844",
    slug: "2023-bmw-m4-competition-vx-23844",
    year: 2023,
    make: "BMW",
    model: "M4",
    trim: "Competition xDrive",
    vin: "WBS43AZ04PCM23844",
    lot: "FL-9348201",
    mileage: 7130,
    location: "Miami, FL",
    seller: "Atlantic Financial Fleet",
    category: "Luxury",
    condition: "Run & Drive",
    titleStatus: "Clean Title",
    primaryDamage: "Front End",
    secondaryDamage: "Minor Dent/Scratch",
    currentBid: 54800,
    buyNow: 68900,
    reserveMet: true,
    auctionStatus: "live",
    auctionType: "Live Auction",
    endsIn: 4350,
    auctionDate: "Today, 4:20 PM",
    watchers: 413,
    bids: 49,
    images: gallery("1555215695-3004980ad54e"),
    specs: { engine: "3.0L Twin Turbo I6", transmission: "Automatic", fuel: "Gasoline", drivetrain: "AWD", color: "Brooklyn Gray", interior: "Black Merino", body: "Coupe", keys: true },
    inspectionNotes: "Starts, shifts, and drives. Front bumper reinforcement and cooling inspection recommended before road use.",
    repairEstimate: 9800,
    shippingEstimate: 1290,
    financingMonthly: 981
  },
  {
    id: "VX-91902",
    slug: "2022-tesla-model-s-plaid-vx-91902",
    year: 2022,
    make: "Tesla",
    model: "Model S",
    trim: "Plaid",
    vin: "5YJSA1E61NF491902",
    lot: "CA-1287742",
    mileage: 11904,
    location: "Los Angeles, CA",
    seller: "Westlake Dealer Group",
    category: "Electric",
    condition: "Enhanced Vehicle",
    titleStatus: "Salvage Title",
    primaryDamage: "Rear End",
    secondaryDamage: "Undercarriage",
    currentBid: 42100,
    buyNow: 61200,
    reserveMet: false,
    auctionStatus: "ending",
    auctionType: "Timed Auction",
    endsIn: 970,
    auctionDate: "Today, 2:45 PM",
    watchers: 620,
    bids: 68,
    images: gallery("1560958089-b8a1929cea89"),
    specs: { engine: "Dual Motor EV", transmission: "Single Speed", fuel: "Electric", drivetrain: "AWD", color: "Pearl White", interior: "Cream", body: "Sedan", keys: true },
    inspectionNotes: "High-voltage battery powers up. Rear structure requires measurement. Autopilot cameras visible.",
    repairEstimate: 14500,
    shippingEstimate: 1580,
    financingMonthly: 899
  },
  {
    id: "VX-77210",
    slug: "2021-mercedes-benz-g63-amg-vx-77210",
    year: 2021,
    make: "Mercedes-Benz",
    model: "G-Class",
    trim: "G63 AMG",
    vin: "W1NYC7HJ2MX377210",
    lot: "TX-5461900",
    mileage: 18442,
    location: "Houston, TX",
    seller: "Premier Recovery Services",
    category: "SUV",
    condition: "Stationary",
    titleStatus: "Insurance",
    primaryDamage: "Flood",
    secondaryDamage: "Electrical",
    currentBid: 79750,
    buyNow: 112000,
    reserveMet: true,
    auctionStatus: "live",
    auctionType: "Live Auction",
    endsIn: 7220,
    auctionDate: "Today, 5:08 PM",
    watchers: 889,
    bids: 91,
    images: gallery("1525609004556-c46c7d6cf023"),
    specs: { engine: "4.0L Biturbo V8", transmission: "Automatic", fuel: "Gasoline", drivetrain: "4MATIC", color: "Obsidian Black", interior: "Classic Red", body: "SUV", keys: false },
    inspectionNotes: "Water line visible at lower cabin trim. Engine not started. Premium wheels and exterior panels present well.",
    repairEstimate: 28750,
    shippingEstimate: 1840,
    financingMonthly: 1530
  },
  {
    id: "VX-45228",
    slug: "2024-ford-f150-raptor-vx-45228",
    year: 2024,
    make: "Ford",
    model: "F-150",
    trim: "Raptor",
    vin: "1FTFW1RG8RFB45228",
    lot: "AZ-6642091",
    mileage: 2240,
    location: "Phoenix, AZ",
    seller: "Desert Commercial Auctions",
    category: "Truck",
    condition: "Run & Drive",
    titleStatus: "Clean Title",
    primaryDamage: "Side",
    secondaryDamage: "Suspension",
    currentBid: 48300,
    buyNow: 74900,
    reserveMet: false,
    auctionStatus: "scheduled",
    auctionType: "Timed Auction",
    endsIn: 188400,
    auctionDate: "May 24, 11:00 AM",
    watchers: 251,
    bids: 17,
    images: gallery("1503736334956-4c8f8e92946d"),
    specs: { engine: "3.5L EcoBoost V6", transmission: "10-Speed Auto", fuel: "Gasoline", drivetrain: "4x4", color: "Avalanche", interior: "Black", body: "Crew Cab", keys: true },
    inspectionNotes: "Clean cabin, starts normally. Right-side suspension and wheel alignment inspection needed.",
    repairEstimate: 11200,
    shippingEstimate: 990,
    financingMonthly: 1034
  },
  {
    id: "VX-64018",
    slug: "2020-porsche-911-carrera-s-vx-64018",
    year: 2020,
    make: "Porsche",
    model: "911",
    trim: "Carrera S",
    vin: "WP0AB2A93LS264018",
    lot: "GA-2100937",
    mileage: 9540,
    location: "Atlanta, GA",
    seller: "Southern Private Seller",
    category: "Sports",
    condition: "Run & Drive",
    titleStatus: "Rebuilt Title",
    primaryDamage: "Hail",
    secondaryDamage: "Cosmetic",
    currentBid: 70600,
    buyNow: 96500,
    reserveMet: true,
    auctionStatus: "buy-now",
    auctionType: "Buy Now",
    endsIn: 36100,
    auctionDate: "Tomorrow, 9:30 AM",
    watchers: 734,
    bids: 54,
    images: gallery("1544636331-e26879cd4d9b"),
    specs: { engine: "3.0L Twin Turbo Flat-6", transmission: "PDK", fuel: "Gasoline", drivetrain: "RWD", color: "Guards Red", interior: "Graphite Blue", body: "Coupe", keys: true },
    inspectionNotes: "Mechanical condition strong. Hail visible across horizontal panels; PPF installed on front clip.",
    repairEstimate: 7200,
    shippingEstimate: 1375,
    financingMonthly: 1318
  },
  {
    id: "VX-30281",
    slug: "2023-toyota-gr-supra-premium-vx-30281",
    year: 2023,
    make: "Toyota",
    model: "GR Supra",
    trim: "Premium",
    vin: "WZ1DB0G06PW030281",
    lot: "NJ-6204430",
    mileage: 3012,
    location: "Trenton, NJ",
    seller: "Metro Lease Exchange",
    category: "Sports",
    condition: "Run & Drive",
    titleStatus: "Clean Title",
    primaryDamage: "Normal Wear",
    secondaryDamage: "None",
    currentBid: 39200,
    buyNow: 52900,
    reserveMet: true,
    auctionStatus: "live",
    auctionType: "Live Auction",
    endsIn: 5290,
    auctionDate: "Today, 4:45 PM",
    watchers: 329,
    bids: 42,
    images: gallery("1533473359331-0135ef1b58bf"),
    specs: { engine: "3.0L Turbo I6", transmission: "Automatic", fuel: "Gasoline", drivetrain: "RWD", color: "Absolute Zero", interior: "Black Alcantara", body: "Coupe", keys: true },
    inspectionNotes: "Very clean lease return. Tires at 7/32. Factory electronics and adaptive suspension verified.",
    repairEstimate: 900,
    shippingEstimate: 820,
    financingMonthly: 712
  }
];

export const bidHistory: BidEvent[] = [
  { id: "B-291", bidder: "m***a", amount: 54800, time: "12 sec ago", source: "Mobile" },
  { id: "B-290", bidder: "prime_auto", amount: 54550, time: "41 sec ago", source: "Autobid" },
  { id: "B-289", bidder: "n***7", amount: 54050, time: "2 min ago", source: "Web" },
  { id: "B-288", bidder: "dealer_214", amount: 53600, time: "3 min ago", source: "Floor" }
];

export const metrics: Metric[] = [
  { label: "GMV this month", value: "$42.8M", delta: "+18.4%", tone: "good" },
  { label: "Active auctions", value: "7,842", delta: "+312 live", tone: "neutral" },
  { label: "Bid velocity", value: "14.2/s", delta: "+9.1%", tone: "good" },
  { label: "Risk queue", value: "28", delta: "6 high", tone: "warn" }
];

export const filters = {
  makes: ["BMW", "Tesla", "Mercedes-Benz", "Ford", "Porsche", "Toyota", "Audi", "Lexus", "Chevrolet"],
  conditions: ["Run & Drive", "Enhanced Vehicle", "Stationary", "Starts", "No Keys"],
  damages: ["Front End", "Rear End", "Side", "Flood", "Hail", "Normal Wear", "Undercarriage"],
  bodyTypes: ["Coupe", "Sedan", "SUV", "Truck", "Convertible", "Van"],
  locations: ["Miami, FL", "Los Angeles, CA", "Houston, TX", "Phoenix, AZ", "Atlanta, GA", "Trenton, NJ"],
  titleStatuses: ["Clean Title", "Salvage Title", "Rebuilt Title", "Insurance"]
};
